import React from "react";


interface IProps {
  Item?: string;
}
const HtmlRenderFormatEbook: React.FC<IProps> = ({ Item }) => {
  let affichage ;
switch (Item?.toLowerCase()) {
  case "epub - format fixe":
  case "epub": {
    affichage =<svg width="30"
      height="30"
      version="1.1"
      viewBox="0 0 240 240"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M119.68,196.88a11.51,11.51,0,0,1-8.17-3.37l-65.6-65.6a11.64,11.64,0,0,1,0-16.46l65.82-65.82a11.9,11.9,0,0,1,16.82,0l36.74,36.74-52.74,52.75L105.47,128l45.68-45.67L121.47,52.7a1.88,1.88,0,0,0-2.67,0L53,118.52a1.64,1.64,0,0,0,0,2.32l65.6,65.59a1.55,1.55,0,0,0,2.2,0l72.87-72.86,7.07,7.07-72.87,72.87A11.51,11.51,0,0,1,119.68,196.88Z"/>
    </svg>
    break;
  }
  case "pdf": {
    affichage =<svg width="30"
    color="red"
    height="30"
    version="1.1"
    viewBox="0 0 240 240"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M44.27,200.61A9,9,0,0,1,37,197.44c-2-2.57-5.17-10,9.71-23.11,8.61-7.61,19.56-13.55,31.64-18.1a278.72,278.72,0,0,0,15.29-28,261.3,261.3,0,0,0,13.71-34.51C102,81.65,99.13,70,99.28,60.08c.3-20.63,6.12-25.2,11-25.4,6.79-.27,11.3,7.86,12.76,22.91.87,9.06-.92,21.36-5,35.47a159.77,159.77,0,0,0,39.1,50.16,192.16,192.16,0,0,1,30.39,2c10.75,1.74,18.05,5.88,20,11.34A8.23,8.23,0,0,1,206,165c-3.87,4.48-12.16,5.67-23.35,3.36-8.93-1.84-19-7.12-29.07-15.06a260.31,260.31,0,0,0-33.11,2.7A194.61,194.61,0,0,0,85,164.37c-8.28,12.82-17.42,24.22-26.1,30.37C52.91,199,48,200.61,44.27,200.61Zm23-28.43a77,77,0,0,0-13.92,9.64c-4.33,3.83-6.46,6.75-7.41,8.53a24.27,24.27,0,0,0,7.21-3.76C57.37,183.57,62.2,178.6,67.24,172.18Zm104.81-18.56a46.71,46.71,0,0,0,12.59,4.9c6.62,1.36,10.55,1,12.45.44-1.53-1.15-4.9-2.86-11.21-3.89C182.16,154.47,177.48,154,172.05,153.62Zm-58.36-47.34c-3,8.41-6.72,17.26-11,26.29-2.9,6.08-6.26,12.56-9.92,19a244.69,244.69,0,0,1,50-7.89,173.39,173.39,0,0,1-15-16.71A168.57,168.57,0,0,1,113.69,106.28Zm-2.94-59a52.45,52.45,0,0,0-1.47,13,58.54,58.54,0,0,0,2.4,16.45c1.34-7.07,1.83-13.24,1.35-18.13A45.79,45.79,0,0,0,110.75,47.23Z"/>
    </svg>
    break;
  }
  case "mp3": {
    affichage =<svg width="30"
    height="30"
    version="1.1"
    viewBox="0 0 240 240"
    xmlns="http://www.w3.org/2000/svg">
<path d="M200.89,103.68c0-.91.06-1.83.06-2.74a81,81,0,1,0-161.93,0c0,1,0,2,.07,2.93a34.46,34.46,0,0,0-18.75,30.64v31.08A34.46,34.46,0,0,0,54.76,200H65a14.28,14.28,0,0,0,14.27-14.27v-71.4A14.28,14.28,0,0,0,65,100.08H54.76a33.91,33.91,0,0,0-5.73.49,71.55,71.55,0,0,1,.7-9.55c4.33-.83,11.27-3.47,20.05-11.24C84,67.25,97.91,58.89,120,58.89S156,67.25,170.21,79.78c8.76,7.76,15.7,10.4,20,11.24a70.5,70.5,0,0,1,.7,9.48,33.91,33.91,0,0,0-5.36-.42H175.39a14.29,14.29,0,0,0-14.27,14.27v71.4A14.29,14.29,0,0,0,175.39,200h10.19A34.47,34.47,0,0,0,220,165.59V134.51A34.47,34.47,0,0,0,200.89,103.68ZM65,110.08a4.27,4.27,0,0,1,4.27,4.27v71.4A4.27,4.27,0,0,1,65,190H54.76a24.45,24.45,0,0,1-24.42-24.43V134.51a24.45,24.45,0,0,1,24.42-24.43ZM176.83,72.3C163.1,60.14,146.72,48.9,120,48.89h0c-26.72,0-43.11,11.25-56.84,23.41a44.72,44.72,0,0,1-10.88,7.42,71,71,0,0,1,135.43,0A45,45,0,0,1,176.83,72.3ZM210,165.59A24.46,24.46,0,0,1,185.58,190H175.39a4.27,4.27,0,0,1-4.27-4.27v-71.4a4.27,4.27,0,0,1,4.27-4.27h10.19A24.46,24.46,0,0,1,210,134.51Z"/>
</svg>
    break;
  }
  case "pack": {
    affichage =<svg width="30"
    height="30"
    version="1.1"
    viewBox="0 0 240 240"
    xmlns="http://www.w3.org/2000/svg">
<path d="M120,29.89,30,70v99.44l90,40.48,90-40.48V70Zm73.37,43.6L165.44,86.07,92.65,53,120,40.84Zm-73.36,33L47.12,73.28,80.44,58.45l72.85,33.09ZM40,81l75,34.17v81.47L40,162.92Zm85,115.64V115.21l34.93-15.92V136l10-4.8V94.79L200,81.47v81.45Z"/>
</svg>
    break;
  }
 
}


  return (
    <>
        {affichage}
    </>
  );
};
export default HtmlRenderFormatEbook;
